import { ReactNode } from 'react'

export type UsersLayoutShadcnComponentProps = {
  children: ReactNode
}

export function UsersLayoutShadcnComponent({ children }: UsersLayoutShadcnComponentProps) {
  return <>{children}</>
}
